export default __webpack_public_path__ + "static/media/applemusic.b1bda394.png";